import req from 'shared/req';
import {FormFieldError} from 'src/utils/errors/FormFieldError';

export interface ChangePassword {
  currentPassword: string;
  password: string;
}

export default class ChangePasswordService {
  static async savePassword(userId: string, credentials: ChangePassword): Promise<$TSFixMe> {
    let response;
    try {
      response = await req({
        url: `/v1/users/${userId}/password`,
        method: 'PUT',
        data: credentials,
      });
    } catch (error) {
      throw new FormFieldError(error);
    }

    return response;
  }
}
